/* eslint-disable react/jsx-props-no-spreading */
import { DrawerProps, Drawer, IconButton, DialogTitle } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';

import React, { useEffect } from 'react';
import useBoolean from '../../../hooks/useBoolean';

export interface IDrawerProps extends Omit<DrawerProps, 'open'> {
  position: DrawerProps['anchor'];
  isOpen: boolean;
  children: string | React.ReactNode;
  onClose: () => void;
  onFullWidth?: (fullwidth: boolean) => void;
}

const CustomDrawer = ({
  position,
  isOpen,
  children,
  onClose,
  title,
  onFullWidth,
  ...props
}: IDrawerProps) => {
  const [toggleResize, { toggle: setToggleResize }] = useBoolean(false);

  useEffect(() => {
    if (onFullWidth) {
      onFullWidth(toggleResize);
    }
  }, [onFullWidth, toggleResize]);

  return (
    <Drawer {...props} anchor={position} open={isOpen} onClose={onClose}>
      {title && (
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: !title ? 'flex-end' : 'space-between',
            alignItems: 'center',
          }}
          bgcolor="primary"
          className="drawerTitle"
        >
          {title}
          <div>
            {onFullWidth && (
              <IconButton onClick={setToggleResize}>
                <AspectRatioIcon />
              </IconButton>
            )}
            <IconButton onClick={onClose}>
              <GridCloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
      )}
      {children}
    </Drawer>
  );
};

export default CustomDrawer;
